import template from './companies.html';
import tr from '../../lib/default-translator.js';

class AdminCompaniesViewModel
{
	constructor(page)
	{
		this.page = page;
	}

	show_companies_help()
	{
		Grape.dialog.open('CompaniesHelp', { employee_id: this.page.bindings.id });
	}
}

class AdminCompaniesPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AdminCompaniesViewModel(this);
		document.title = tr('Manage Companies');
		window.current_page_title(tr('Add/Edit Companies'));
	}
}

export default {
	route: '[/]admin/companies',
	page_class: AdminCompaniesPage,
	template: template,
	template_filename: 'translation/companies'
};
